module.exports = __webpack_public_path__ + "img/strike.dd63b495.svg";